import { render } from "./component-payer-additional-bank.vue?vue&type=template&id=4b672e4d"
import script from "./component-payer-additional-bank.vue?vue&type=script&setup=true&lang=js"
export * from "./component-payer-additional-bank.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-payer-additional-bank.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b672e4d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b672e4d', __exports__)) {
    api.reload('4b672e4d', __exports__)
  }
  
  module.hot.accept("./component-payer-additional-bank.vue?vue&type=template&id=4b672e4d", () => {
    api.rerender('4b672e4d', render)
  })

}


export default __exports__